import React from 'react';
import styled from "styled-components";

const StyledTenant = styled.div`
  background-color: ${(props) => props.tenantName === props.activeTenant.name ? '#0DA39E' : '#0288BD'};
  font-size: 2rem;
  border: 1px solid white;
  border-radius: 3px;
  width: 100%;
  padding: 2rem;
  color: white;
  font-weight: bolder;
  letter-spacing: 2px;
  
  :hover {
    background-color: white;
    color: #0288BD;
    border: 1px solid #0288BD;
    cursor: pointer;
  }
`

const Tenant = ({tenant, handleClick, selectedTenant}) => {
  const onClick = () => {
    handleClick(tenant);
  }

  return (
    <StyledTenant tenantName={tenant.name} activeTenant={selectedTenant} onClick={onClick} className={'tenant'}>
      {tenant.name} {selectedTenant.name === tenant.name ? '(Selected)' : null}
    </StyledTenant>
  )
}

export default Tenant;